import { memo } from 'react';
import { useGetComponentParametersSingle } from '../../../Core/Hooks/HooksParameters/useGetComponentParameters';
import { COMPONENTS } from '../../../Domain/Settings/Constants/ComponentsParameter/ComponentsParameter';
import { TYPE_FETCH_PARAMETERS } from '../../../Domain/Settings/Constants/Constants';

const PaymentMethods = ({ parameters }) => {
  const paymentMethods = useGetComponentParametersSingle(
    COMPONENTS.PAYMENTS_METHODS_SECTION,
    TYPE_FETCH_PARAMETERS.MAIN_DETAIL,
    parameters?.ALL_PAYMENT_LOGO?.code
  );

  return (
    <div className="container pb-4 my-0">
      <div style={{ scrollX: 'auto' }} className="d-flex flex-wrap justify-content-center gap-3">
        {paymentMethods?.length > 0 &&
          paymentMethods?.map((method, index) => (
            <img
              key={index}
              src={method?.desktop_image || ''}
              alt="method payment logo"
              style={{ width: '100px', height: '80px', objectFit: 'contain', opacity: '0.5' }}
            />
          ))}
      </div>
    </div>
  );
};

export default memo(PaymentMethods);
